import { render, staticRenderFns } from "./VendorSearch.vue?vue&type=template&id=7b6cbb3c&"
import script from "./VendorSearch.vue?vue&type=script&lang=ts&"
export * from "./VendorSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports